const referenceTokenPattern = /\{\{ref:([^}]+)\}\}/g;

export type ReferenceTokenSegment =
  | { type: 'text'; value: string }
  | { type: 'ref'; referenceId: string };

/**
 * Splits a string on `{{ref:uuid}}` tokens into plain text and reference segments.
 */
export function parseReferenceTokens(text: string): ReferenceTokenSegment[] {
  if (text.length === 0) {
    return [];
  }

  const segments: ReferenceTokenSegment[] = [];
  let lastIndex = 0;
  const pattern = new RegExp(referenceTokenPattern.source, 'g');
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(text)) !== null) {
    const referenceId = match[1].trim();
    if (match.index > lastIndex) {
      segments.push({
        type: 'text',
        value: text.slice(lastIndex, match.index),
      });
    }
    if (referenceId.length > 0) {
      segments.push({ type: 'ref', referenceId });
    }
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) });
  }

  return segments;
}
